/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_SummaryInputs */

const cs_audit_summary = /** @type {(inputs: Audit_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shrnutí`)
};

const en_audit_summary = /** @type {(inputs: Audit_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Audit_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_summary = /** @type {((inputs?: Audit_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_summary(inputs)
	return cs_audit_summary(inputs)
});